<template>
  <div id="app">

    <router-view/>
      <notifications :duration="-1" group="foo" />
    <md-snackbar :md-position="'center'" :md-duration="Infinity" :md-active="isTrial && showTrial " md-persistent>
      <span>Your FREE TRIAL expires in {{trialDaysLeft}} Days! Join now & save 16% on an Annual Plan!   <a class="md-primary" :href="'/#/account?tab=billing'">Upgrade Now</a>  </span>
      <md-button class="md-primary small-on-mobile" @click="showTrial=false">Hide</md-button>
    </md-snackbar>

    <!--NOTIFICATION-->
    <div style="margin-top: -308px;display: inline-block;vertical-align: top" class="phone">
      <md-card v-for="notification in accountNotifications" class="md-accent" md-with-hover style="margin-top: 10px;height: 60px">
        <md-ripple>



          <md-card-content>
            <span>{{notification.description}} in date: {{notification.created_at | date(user.account_id.timezone)}} with the amount of: ${{notification.amount}}</span>
            <md-button class="md-raised" @click="pay(notification)" style="margin-top: -5px;background-color: #2ecc71; color: white" :disabled="loadingButton">
              Pay now
              <md-progress-spinner v-if="loadingButton" :md-diameter="15" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>

            </md-button>
            <md-button class="md-raised" @click="billingSection()" style="margin-top: -5px;">Check billing</md-button>
            <md-button class="md-raised" style="margin-top: -5px;" @click="dismiss(notification)">Dismiss</md-button>

          </md-card-content>

        </md-ripple>
      </md-card>
    </div>

    <!--NOTIFICATION-->
<!--    <md-dialog v-if="user" :md-active.sync="user.account_id.fast_start_overlay" style="width: 20%">-->

<!--     <md-dialog-content>-->
<!--         <img class="image-logo" src="https://s3.us-east-2.amazonaws.com/nmet-static-files/logos/JN5aF8SiTR.jpeg" @click="goToChecklist()" style="cursor: pointer">-->
<!--     </md-dialog-content>-->

<!--      <md-dialog-actions>-->
<!--        <md-button class="md-primary" @click="neverShowAgain()"><md-icon>done</md-icon> Never show again</md-button>-->
<!--      </md-dialog-actions>-->
<!--    </md-dialog>-->


    <div class="backdrop" v-if="isRegisterState">
      <div class="modal-content-2">
        <h3>Create an account</h3>
        <div class="mcard">
          <div class="card-body-2">
            <md-field>
              <label>Restaurant Name</label>
              <md-input v-model="registerModel.company" v-validate="'required'" name="company" @input="updateForm('account','company_name',$event)"></md-input>
              <span class="md-error-2" v-if="errors.has('company')">The restaurant name is required</span>

            </md-field>

            <md-field>
              <label>Email</label>
              <md-input v-model="registerModel.email" v-validate="'required|email'" name="email"></md-input>
              <span class="md-error-2" v-if="errors.has('email')">{{  errors.first('email') }}</span>
            </md-field>

            <div class="input-two-lines">
            <md-field style="margin-right: 10px">
              <label>First Name</label>
              <md-input   v-model="registerModel.first_name" v-validate="'required'" name="first_name" @input="updateForm('user','first_name',$event)"></md-input>
              <span class="md-error-2" v-if="errors.has('first_name')">First name is required</span>

            </md-field>

            <md-field>
              <label>Last Name</label>
              <md-input v-model="registerModel.last_name" v-validate="'required'" name="last_name" @input="updateForm('user','last_name',$event)"></md-input>
              <span class="md-error-2" v-if="errors.has('last_name')">Last name is required</span>

            </md-field>

            </div>

            <md-field style="margin-right: 10px">
              <label>Password</label>
              <md-input type="password"   v-model="registerModel.password" v-validate="'required'" name="password"></md-input>
              <span class="md-error-2" v-if="errors.has('password')">Password is required</span>

            </md-field>


          </div>
        </div>
        <div style="    margin-top: 10px;
    margin-bottom: 10px;">
          <md-button :disabled="loadingRegister"  class="md-raised md-primary" @click="registerAccount()">Create account</md-button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
    /* eslint-disable */
    import Vue from 'vue';
    import { mapState, mapMutations } from 'vuex'
    import moment from 'moment';
    import momentTz from 'moment-timezone';
    import VueMask from 'v-mask';
    import FBSignInButton from 'vue-facebook-signin-button';
    import GSignInButton from 'vue-google-signin-button'
    import axios from 'axios'
    import * as VueGoogleMaps from 'vue2-google-maps'

    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyDJ2sUaWArG8-2hLC0v9_IHONL08XgX2qg',
            libraries: 'places', // This is required if you use the Autocomplete plugin
            // OR: libraries: 'places,drawing'
            // OR: libraries: 'places,drawing,visualization'
            // (as you require)

            //// If you want to set the version, you can do so:
            // v: '3.26',
        },
    })

    Vue.config.productionTip = false;

    // const VueUploadComponent = require('vue-upload-component');
    // Vue.component('file-upload', VueUploadComponent);

    Vue.use(VueMask);
    Vue.use(FBSignInButton);

    Vue.use(GSignInButton);

    // const VueUploadComponent = require('vue-upload-component')

    Vue.filter('phone', function (phone) {
        return phone.replace(/[^0-9]/g, '')
            .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    });

    Vue.filter('date', function (date, timezone) {
        // return moment.parseZone(String(date)).local().format('MM-DD-YYYY h:mm a')
        return moment.utc(String(date)).tz(timezone).format('MM-DD-YYYY h:mm a');
    });

    Vue.filter('dt', function (date, timezone) {
        // return moment.parseZone(String(date)).local().format('MM-DD-YYYY h:mm a')
        return moment.utc(String(date)).set({hour:15,minute:0,second:0,millisecond:0}).tz(timezone).format('MMMM D, YYYY ');
    });

    Vue.filter('dateVip', function (date) {
        // return moment.parseZone(String(date)).local().format('MM-DD-YYYY h:mm a')
        return moment(String(date)).format('MM-DD-YYYY h:mm a');
    });

    Vue.filter('groupsDate', function (date) {
        return moment(String(date)).format('MMMM Do YYYY, h:mm a');
    })

    Vue.filter('birthday', function (date) {
        return moment(String(date)).format('MM-DD-YYYY')
    });

    Vue.filter('count', function (count) {
        return count.length;
    });

 export default {
     name: 'app',
        computed: {
            ...mapState({
                show: state => state.notify.show,
                isTrial: state =>state.auth.user ?  state.auth.user.is_trial && !state.auth.user.current_subscription_status && ( state.auth.user.user_roles.indexOf("Affiliate") === -1 &&  state.auth.user.user_roles.indexOf("Owner") > -1 )  :false,
                trialExpireDay: state => state.auth.user ? state.auth.user.trial_ends_at : false,
                token: state => state.auth.accessToken,
                user: state => state.auth.user,
                accountNotifications: state => state.accountNotifications,
                isRegisterState: state => state.auth.register_state

            }),
            trialDaysLeft(){
                if(this.trialExpireDay){
                let expireDate=moment(this.trialExpireDay);
                let now=moment();

               return expireDate.diff(now, 'days')
                } else {
                    return 0;
                }

            },
        },
     data(){
       return {
         loadingRegister:false,
           showTrial:true,
           notifications:[],
           showFail:true,
           solved:0,
           loadingButton:false,
           showDialog:true,
         registerModel:{
           email:"",
           first_name:"",
           last_name:"",
           company:"",
           password:"",
           repeat_password:"",
           affiliate_code:"",

         }
       }
     },
     watch: {
         show () {
             if (this.show) {

                 this.$notify({
                     title: this.$store.state.notify.title,
                     text: this.$store.state.notify.text,
                     type: this.$store.state.notify.type,
                     duration: this.$store.state.notify.type ==="success" ? 3000 : -1,
                     group: 'foo'
                 })
             }
             this.disableNotify()
         },
         'user.account_id.sms_phone_number'(val){

         },

     },
     mounted(){
         let em=this;
         this.$store.dispatch('getAccountNotifications');

         // this.notifications=[];

         // if(this.user){
         //
         //     this.getNotifications();
         // }
     window.setInterval(function () {
         em.$store.dispatch('checkTokenValidity')
     }, 30000)


     },
     methods: {
         ...mapMutations( [
             'disableNotify'
         ]),
       updateForm(type,item,event){

         if(type==="user"){

           this.$store.commit('updateUser',{item:item,value:event})

         } else if(type==="account"){

           this.$store.commit('updateAccount',{item:item,value:event})

         }

       },
       registerAccount(){
         let em=this;
         this.loadingRegister=false;
         this.$validator.validateAll().then(result => {

           if(result){
             this.loadingRegister=true;


             axios.post('/api/new-register', this.registerModel, {}).then((response) => {

               em.loadingRegister=false;
               em.$store.commit('showNotify', {title: 'Success',
                 text: 'The register is complete', type: 'success'});

               this.$store.commit('UPDATE_AUTH', {
                 isLoggedIn: true,
                 user: response.data.user,
                 accessToken: response.data.token,
                 register_state:false

               })

               this.$router.push({ path: '/checklist' });
               // em.getNotifications(false);

             }, (err) => {
               console.log(err);
               em.loadingRegister=false;
               this.$store.commit('showNotify', {title: 'Error', text: err.response.data.message, type: 'error'})
             })


           }

         });
       },
         getNotifications(){
             let em=this;
                 axios.get('api/notifications/' + em.user.account_id.id, {
                     headers: {
                         'Authorization': 'Bearer ' + this.token
                     }
                 }).then((response) => {
                     em.notifications = response.data.notifications;
                 }, (err) => {
                     console.log(err)
                     // em.$store.commit('showNotify', {
                     //     title: 'Request Invalid',
                     //     text: 'The request data is invalid',
                     //     type: 'error'
                     // })
                 })
         },
         pay(notification){
             let em=this;

             em.loadingButton=true;
             axios.put('/api/pay/'+notification.id, {notification:notification}, {headers:{
                     'Authorization': 'Bearer '+em.token
                 }}).then((response) => {

                 em.loadingButton=false;
                 em.$store.commit('showNotify', {title: 'Success', text: '', type: 'success'});
                 // em.getNotifications(false);
                 this.$store.dispatch('getAccountNotifications');
             }, (err) => {
                 console.log(err);
                 em.loadingButton=false;
                 this.$store.commit('showNotify', {title: 'Error', text: err.response.data.message, type: 'error'})
             })
         },
         billingSection(){
             this.$router.push({ path: '/account/billing' });
         },
         goToChecklist(){
             this.user.account_id.fast_start_overlay=false;
             this.$router.push({ path: '/checklist' });
         },
         neverShowAgain(){

             this.$store.commit('updateAccount',{item:'fast_start_overlay',value:0});
             this.$store.dispatch('updateUserAccounts',{password:this.password,showNotfication:false});

         },
         dismiss(notification){
             let em=this;

             axios.put('/api/dismiss-notification/'+notification.id, {notification:notification}, {headers:{
                     'Authorization': 'Bearer '+em.token
                 }}).then((response) => {
                 this.$store.dispatch('getAccountNotifications');
                 em.$store.commit('showNotify', {title: 'Success', text: 'Notification marked as solved', type: 'success'});
                 // em.getNotifications(false);

             }, (err) => {
                 console.log(err);
                 this.$store.commit('showNotify', {title: 'Error', text: err.response.data.message, type: 'error'})
             })
         }
     },

    }
</script>

<style lang="scss" >
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.md-menu-content .md-select-menu {
  z-index: 10000;
}



@media only screen and (max-width: 600px) {
  .small-on-mobile {
    font-size: 10px!important;

  }
  .phone {
    margin-top: 20px;
  }
}
.image-logo {

  width: 100%;
}

.backdrop {


  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: hidden; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

@media only screen and (max-width: 430px) {
  .modal-content {
    width: 90%;
  }
}

@media only screen and (min-width: 431px) {
  .modal-content-2 {
    width: 35%;
  }
}


.modal-content-2 {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */

  border: 1px solid #888;


  h3 {    margin-top: 13px;
    margin-bottom: 13px;

  }

  .mcard {

    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #f7f6f5;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .1875rem;



    .card-body-2 {
      flex: 1 1 auto;
      padding: 1.5rem;

      .input-two-lines {
        display: flex;
        input {
          width: 100%;
        }
      }




    }

  }


}

.md-error-2 {
  color: red!important;
  padding-top: 5px;
  opacity: unset!important;
  height: 20px;
  position: absolute;
  bottom: -22px;
  font-size: 12px;
  transition: .3s cubic-bezier(.4,0,.2,1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue